import {useState} from "react";

import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {REGISTRATION_WIZARD_ENTRY_CONTENT} from "../../constants/registration_wizard_entry_content";
import {UnlockChoiceEntryPoint} from "../../types/UnlockChoiceEntryPoint";
import {RegistrationWizardEmailForm} from "./RegistrationWizardEmailForm";
import {RegistrationWizardEmailStepAccount} from "./RegistrationWizardEmailStepAccount";
import {RegistrationWizardStepLayout} from "./RegistrationWizardStepLayout";

interface IProps {
    titleId: string;
    onAdvance: () => Promise<void>;
}

export const RegistrationWizardEmailStep = (props: IProps) => {
    const {titleId, onAdvance} = props;
    const wizardEntry = useAppSelector((state) => state.registrationFlow.wizardEntry);
    const isAuthenticated = useIsAuthenticated();
    const [isAccountView] = useState(isAuthenticated);
    const {data: userProfile} = useGetUserProfileQuery();
    const content = REGISTRATION_WIZARD_ENTRY_CONTENT[wizardEntry ?? UnlockChoiceEntryPoint.PRICE];

    return (
        <RegistrationWizardStepLayout titleId={titleId} title={content.title} description={content.description}>
            {isAccountView ? <RegistrationWizardEmailStepAccount email={userProfile?.email ?? ""} onAdvance={onAdvance} /> : <RegistrationWizardEmailForm />}
        </RegistrationWizardStepLayout>
    );
};
import {useState} from "react";

import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {REGISTRATION_WIZARD_ENTRY_CONTENT} from "../../constants/registration_wizard_entry_content";
import {UnlockChoiceEntryPoint} from "../../types/UnlockChoiceEntryPoint";
import {RegistrationWizardEmailForm} from "./RegistrationWizardEmailForm";
import {RegistrationWizardEmailStepAccount} from "./RegistrationWizardEmailStepAccount";
import {RegistrationWizardStepLayout} from "./RegistrationWizardStepLayout";

interface IProps {
    titleId: string;
    onAdvance: () => Promise<void>;
}

export const RegistrationWizardEmailStep = (props: IProps) => {
    const {titleId, onAdvance} = props;
    const wizardEntry = useAppSelector((state) => state.registrationFlow.wizardEntry);
    const isAuthenticated = useIsAuthenticated();
    const [isAccountView] = useState(isAuthenticated);
    const {data: userProfile} = useGetUserProfileQuery();
    const content = REGISTRATION_WIZARD_ENTRY_CONTENT[wizardEntry ?? UnlockChoiceEntryPoint.PRICE];

    return (
        <RegistrationWizardStepLayout titleId={titleId} title={content.title} description={content.description}>
            {isAccountView ? <RegistrationWizardEmailStepAccount email={userProfile?.email ?? ""} onAdvance={onAdvance} /> : <RegistrationWizardEmailForm />}
        </RegistrationWizardStepLayout>
    );
};
